<mat-form-field [appearance]="'outline'" [formGroup]="group">
  <mat-label> {{ field.label }} </mat-label>
  <input
    readonly
    matInput
    (click)="onClick()"
    [value]="selectedTime"
    [placeholder]="'--:--'"
    [formControlName]="field.key || null"
    [required]="(field.key && group?.get(field.key)?.errors !== null && group?.get(field.key)?.errors['required']) || field.required"
    #timeInput
  />
  <mat-icon style="cursor: pointer;" (click)="openDialog()" matSuffix>access_time</mat-icon>
  <mat-hint align="start"><strong>{{field.hint}}</strong> </mat-hint>
  <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
    <mat-error *ngIf="field.key && group?.get(field.key)?.hasError(validation.name)">{{validation.message}}</mat-error>
  </ng-container>
</mat-form-field>


